<script>
import ElTableDraggable from 'element-ui-el-table-draggable'
import pageMixin from '@src/mixins/pagination'
import { productTypeList, productTypeFilter, prepaidCapacityFilter, priceStatusFilter } from '@utils/filter-value-to-text'
import { formatDateRange } from '@utils/format-date'
import { messageDelete } from '@utils/message'
import { messageBoxDelete } from '@utils/message-box'

export default {
  page: {
    title: '服務項目',
    meta: [{ name: 'description', content: 'Prepaid List' }],
  },
  components: {
    ElTableDraggable,
  },
  filters: {
    productTypeFilter,
    priceStatusFilter,
    prepaidCapacityFilter,
    formatDateRange,
  },
  mixins: [pageMixin],
  props: {
    merchantProducts: {
      type: Array,
      required: true,
    },
    serviceCategory: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      default: ''
    },
    tableCheckboxShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tableData: [],
      selectedPrices: [],
      selectedPricesId: [],
      selectedDetail: {},
      filterData: {
        state: '',
        productId: '',
        type: '',
        // body:'',
        petCategoryId: '',
        petSizeId: '',
      },
      productTypeList: Object.freeze(productTypeList),
      visibleDetail: false,
      previousPage: 1,
      previousTotal: 0,
      tryingFetchDetail: false,
      tryingFetch: false,
      pageSize: 10,
      isFilterChange: false,
      currentPage: 1,
      action: '',
      changeToDelete: false
    }
  },
  computed: {

    activeSizeList() {
      let active = []
      if (this.filterData.petCategoryId) {
        active = this.serviceCategory.find((item) => {
          return item.id === this.filterData.petCategoryId
        }).children
      }
      return active
    },
    templateRouter() {
      const typeRouter = {
        'service': 'tempService',
        'addition': 'tempService',
        'spa': 'tempSpa',
        'daycare': 'tempDaycare'
      }
      return typeRouter[this.type]
    },
    searchTableShow() {
      const showArr = ['service', 'addition', 'daycare']
      return showArr.includes(this.type)
    }
  },
  watch: {
    tableData(nvl) {
      if (this.$refs.pagination) {
        this.$refs.pagination.updateTotal(this.forPropsTotal)
      }
    },
    filterData: {
      handler() {
        this.isFilterChange = true
      },
      deep: true,
    },
    /**
     * @description 改變每頁資料量時，要重新去打API
     */
    pageSize: {
      handler(val) {
        if (this.currentPage !== 1) {
          this.currentPage = 1
        } else {
          this.tryToFetchList()
        }
      },
      immediate: false,
    },
    'filterData.petCategoryId': function (value) {
      this.filterData.petSizeId = ''
    },
    /**
     * @description 改變頁數時，會做的事情
     */
     currentPage(nvl) {
      this.tryToFetchList()
    }
  },
  created() {
    if (this.$route.params.createPrice) this.createDetail()
  },
  mounted() {
    this.tryToFetchList()
  },
  methods: {
    async tryToFetchListFilter() {
      if (this.currentPage !== 1) {
        this.currentPage = 1
      }
      this.pageQuery.limit = this.pageSize
      const serviceInfo = this.type === 'service' ?
        this.composeServiceAPIInfo('product/fetchNormalServiceData', 'cosmetic') :
        this.composeServiceAPIInfo('product/fetchAdditionalService', 'cosmetic-add')
      this.tryingFetch = true
      this.dealFilterData()
      const { items } = await this.$store.dispatch(`${serviceInfo.url}`, Object.assign({}, this.filterData, { paginate: this.currentPage }, serviceInfo.payload))
      this.tableData = items
      this.isFilterChange = false
      this.tryingFetch = false
    },
    /**
     * @description 增加filterData key值
     */
    dealFilterData() {
      this.$set(this.filterData, 'branchStoreId', this.filterData.productId)
    },
    /**
     * @description 一開始進畫面，會打這支，做撈資料
     */
    async tryToFetchList() {
      try {
        this.forPropsTotal = 0
        this.pageQuery.limit = this.type === 'spa' ? '0' : this.pageSize
        const serviceInfo = this.fetchTypeRouter()
        const { items, pagination } = await this.$store.dispatch(`${serviceInfo.url}`, Object.assign(
          {}, this.filterData, this.pageQuery, { paginate: 1 }, serviceInfo.payload
        ))
        this.forPropsTotal = pagination?.total || 10
        this.tableData = items
      } catch (error) {
        console.error(error.message)
      } finally {
        this.tryingFetch = false
      }
    },
    fetchTypeRouter() {
      // type === service -> 一般服務
      // type === addition -> 加購服務
      // type === spa -> spa
      const fetchType = {
        'service': this.composeServiceAPIInfo('product/fetchNormalServiceData', 'cosmetic'),
        'addition': this.composeServiceAPIInfo('product/fetchAdditionalService', 'cosmetic-add'),
        'spa': this.composeServiceAPIInfo('product/fetchSpaService', 'spa'),
        'daycare': this.composeServiceAPIInfo('product/fetchNormalServiceData', 'cosmetic'),
      }
      return fetchType[this.type]
    },
    /**
     * @description 組api格式
     * @param {String} url 
     * @param {String} type 
     */
    composeServiceAPIInfo(url, type) {
      return {
        url,
        payload: {
          types: [type]
        }
      }
    },
    /**
     * @descrption 美容服務 -> 一般服務 or 加購服務 -> 點擊各列之後，做事
     * @param {*} row 
     */
    async goToDetail(row) {
      const title = {
        'service': '編輯一般服務',
        'addition': '編輯加購項目',
        'spa': `編輯${this.$t('service.SPA')}項目`,
        'daycare': '編輯安親住宿'
      }
      this.$store.commit('title/SET_TITLE', title[this.type])
      this.$router.push({
        name: 'view-service',
        params: {
          type: this.type,
          thisServiceId: row.id,
          merchantProducts: this.merchantProducts,
          serviceCategory: this.serviceCategory,
        }
      })
      this.$emit('update-mode', 'edit')
    },
    createDetail() {
      const title = {
        'service': '新增一般服務',
        'addition': '新增加購項目',
        'spa': `新增${this.$t('service.SPA')}項目`,
      }
      this.$store.commit('title/SET_TITLE', title[this.type])
      this.$router.push({
        name: 'add-service',
        params: {
          type: this.type,
          merchantProducts: this.merchantProducts,
          serviceCategory: this.serviceCategory,
        }
      })
      this.$emit('update-mode', 'add')
    },
    onFilterReset() {
      this.tryToFetchList()
    },
    /**
     * @description 勾選到checkbox後，要做什麼事
     * @param {Object} selected 勾選到的物件
     */
    handleSelectionChange(selected) {
      this.selectedPricesId = selected.map(({ id }) => id)
    },
    /**
     * @description 拖拉「開始」瞬間
     */
    startDraggable() {
      this.cacheTableData = [...this.tableData]
    },
    /**
     * @description 拖拉「結束瞬間」
     * @param {*} targetObject：被移動的物件
     * @param {*} list：被移動過後的陣列
     */
    endDraggable({ targetObject, list }) {
      try {
        this.tryingFetch = true
        let action = 'before'
        let refId = ''
        const newTargetIndex = list.findIndex(item => item.ordering === targetObject.ordering) // 新移到的位置
        if (newTargetIndex === 0) {
          action = 'before'
          refId = list[1].id
        }
        if (newTargetIndex + 1 === list.length) {
          action = 'after'
          refId = list[newTargetIndex - 1].id
        }
        if (newTargetIndex !== 0 && newTargetIndex + 1 !== list.length) {
          refId = list[newTargetIndex + 1].id
        }
        this.tryToOrderingPriceGroup(action, refId, list[newTargetIndex].id)
      } catch (error) {
        this.tryingFetch = false
        console.error(error.message)
      }
    },
    /**
     * @description 拖拉結束要打api
     * @param {*} ordering：點擊到的id
     * @param {*} indexDiff：兩者間距
     */
    async tryToOrderingPriceGroup(action, refId, id) {
      try {
        const urlRouter = {
          'service': 'product/orderingServicePriceGroup',
          'addition': 'product/orderingAdditionalPriceGroup',
          'spa': 'product/orderingSpaPriceGroup',
        }

        await this.$store.dispatch(`${urlRouter[this.type]}`, {
          orderingData: {
            id,
            action,
            refId,
          },
        })
        this.tryToFetchList()
      } catch (error) {
        this.tryingFetch = false
        console.error(error.message)
      }

    },
    async deleteSelected() {
      try {
        if (this.selectedPricesId.length > 0) {
          await messageBoxDelete('此服務項目')
          await this.$store.dispatch('product/serviceRemove', { ids: this.selectedPricesId })
          messageDelete()
          this.tryToFetchList()
        }
      } catch (error) {
        console.error(error.message)
      }
    }
  },
}
</script>

<template>
  <div>
    <div class="baseTableAdd">
      <div :class="$style.btnTop" class="btn-top-box right">
        <span>
          <el-button class="is-round is-add" type="primary" @click="createDetail({})">
            <BaseIcon name="plus" />
            <span>新增項目</span>
          </el-button>
        </span>
        <span>
          <el-button v-if="type === 'addition'" class="is-round is-add" @click="deleteSelected"
            :class="$style['btnTop__delete']">
            <BaseIcon name="trash-alt" />
            <span>刪除選取</span>
          </el-button>
        </span>
      </div>
    </div>
    <div>
      <BaseTableSearch v-if="searchTableShow" v-slot="{ fields }" hide-action :default-value="filterData"
        class="isForTab2" :class="$style.displaySearchTable" @reset="onFilterReset"
        @tryToFetchList="tryToFetchListFilter">
        <!-- <el-form-item prop="state">
          <el-select v-model="fields.state" placeholder="上架狀態" @change="tryToFetchListFilter">
            <el-option label="所有狀態" value=""></el-option>
            <el-option label="上架中" value="1"></el-option>
            <el-option label="已下架" value="0"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item prop="productId">
          <el-select v-model="fields.productId" placeholder="所有地點" @change="tryToFetchListFilter">
            <el-option label="所有分店" value=""></el-option>
            <el-option v-for="(product, index) in merchantProducts" :key="index" :label="product.name" :value="product.id"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item prop="petCategoryId">
          <el-select v-model="fields.petCategoryId" :placeholder="`選擇${$t('reserve.CLIENT')}類別`"
            @change="tryToFetchListFilter">
            <el-option label="所有類別" value></el-option>
            <el-option v-for="item in serviceCategory" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </BaseTableSearch>
      <div class="el-table-wrapper">
        <ElTableDraggable handle=".handle" @drag="startDraggable" @drop="endDraggable">
          <el-table ref="multipleTable" v-loading="tryingFetch" 
            :data="tableData" element-loading-text="取得服務資訊中"
            style="padding: 20px;"
            :class="$style['table']" @row-click.once="goToDetail" @selection-change="handleSelectionChange"
            >
            <template v-if="templateRouter === 'tempService'">
              <el-table-column v-if="tableCheckboxShow" type="selection" width="100px">
              </el-table-column>
              <el-table-column v-slot="{ row }" label="圖片" min-width="150">
                <el-image class="image image--square" :src="row.images.length > 0 ? row.image : ''" fit="cover">
                  <div slot="error">
                    <BaseIcon name="image" class="image--error" />
                  </div>
                </el-image>
              </el-table-column>
              <el-table-column v-slot="{ row }" label="名稱" prop="title" min-width="180">
                <div>{{ row.title }}</div>
              </el-table-column>
              <el-table-column v-slot="{ row }" label="類別" prop="type" min-width="170">{{ row.petCategoryTitle }}
              </el-table-column>
              <el-table-column v-if="!filterData.productId && !filterData.petCategoryId" min-width="60">
                <el-tooltip content="拖曳改變排序" placement="top">
                  <el-button type="text" class="handle" :class="$style.btnGripVertical">
                    <BaseIcon icon-style="fas" name="fa-grip-dots-vertical" />
                  </el-button>
                </el-tooltip>
              </el-table-column>
            </template>

            <template v-if="templateRouter === 'tempSpa'">
              <el-table-column v-if="tableCheckboxShow" type="selection" width="100px">
              </el-table-column>
              <el-table-column v-slot="{ row }" label="圖片" min-width="150">
                <el-image class="image image--square" :src="row.images.length > 0 ? row.image : ''" fit="cover">
                  <div slot="error">
                    <BaseIcon name="image" class="image--error" />
                  </div>
                </el-image>
              </el-table-column>
              <el-table-column v-slot="{ row }" label="名稱" prop="type" min-width="170">{{ row.title }}
              </el-table-column>
              <el-table-column v-slot="{ row }" label="主打功能" prop="type" min-width="170">{{ row.feature }}
              </el-table-column>
              <el-table-column v-slot="{ row }" label="價格與時間" prop="type" min-width="170">
                <p>NT$ {{ row.minPrice }} ~ NT$ {{ row.maxPrice }}</p>
                <p>{{ row.minTime }} ~ {{ row.maxTime }} 分鐘</p>
              </el-table-column>
              <el-table-column v-if="!filterData.productId && !filterData.petCategoryId" min-width="60">
                <el-tooltip content="拖曳改變排序" placement="top">
                  <el-button type="text" class="handle" :class="$style.btnGripVertical">
                    <BaseIcon icon-style="fas" name="fa-grip-dots-vertical" />
                  </el-button>
                </el-tooltip>
              </el-table-column>
            </template>

            <template v-if="templateRouter === 'tempDaycare'">
              <el-table-column v-if="tableCheckboxShow" type="selection" width="100px">
              </el-table-column>
              <el-table-column v-slot="{ row }" label="圖片" min-width="150">
                <el-image class="image image--square" :src="row.images.length > 0 ? row.image : ''" fit="cover">
                  <div slot="error">
                    <BaseIcon name="image" class="image--error" />
                  </div>
                </el-image>
              </el-table-column>
              <el-table-column v-slot="{ row }" label="名稱" prop="type" min-width="170">{{ row.title }}
              </el-table-column>
              <el-table-column v-slot="{ row }" label="服務類型" prop="type" min-width="170">{{ row.feature }}
              </el-table-column>
              <el-table-column v-slot="{ row }" label="時間長度" prop="type" min-width="170">
                <p>NT$ {{ row.minPrice }} ~ NT$ {{ row.maxPrice }}</p>
                <p>{{ row.minTime }} ~ {{ row.maxTime }} 分鐘</p>
              </el-table-column>
              <el-table-column v-slot="{ row }" label="類別" prop="type" min-width="170">{{ row.feature }}
              </el-table-column>
              <el-table-column v-if="!filterData.productId && !filterData.petCategoryId" min-width="60">
                <el-tooltip content="拖曳改變排序" placement="top">
                  <el-button type="text" class="handle" :class="$style.btnGripVertical">
                    <BaseIcon icon-style="fas" name="grip-vertical" />
                  </el-button>
                </el-tooltip>
              </el-table-column>
            </template>
          </el-table>
          <BasePagination ref="pagination" :class="$style.paginationStyle" show-size :current-page.sync="currentPage"
            :page-size.sync="pageSize" :select-mini-none="false" />
        </ElTableDraggable>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.table {
  @include layer-elevation(5);
}

.btnTop {
  display: flex;
  justify-content: flex-end;

  @include max-sm {
    :global {
      .el-button.is-add {
        width: 100% !important;
      }
    }
  }

  &__delete {
    background-color: #F06C6C;
    color: white;

    &:hover {
      background-color: #FF6C6C;
      color: white;
    }

    &:focus {
      background-color: #F06C6C;
      color: white;
    }
  }
}

.baseTableAdd {
  right: 0px;
}

.btnGripVertical {
  span svg {
    color: $color-primary;
  }
}

.displaySearchTable {
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  @include max-sm {
    flex-direction: column;
  }

  :global {
    .btn-box-inline {
      margin-top: 0 !important;
    }

    .el-form-item {
      &:first-child {
        @include max-md {
          margin-top: 1rem;
        }
      }

      margin-bottom: 5px;
    }
  }

  &>div {
    &:first-child {
      margin-right: 1rem;
    }

    @include max-sm {
      width: 100%;
    }
  }
}

.paginationStyle {
  overflow-x: scroll;
}
</style>